import { render } from "./TermConditionModal.vue?vue&type=template&id=157f23c7&scoped=true"
import script from "./TermConditionModal.vue?vue&type=script&lang=js"
export * from "./TermConditionModal.vue?vue&type=script&lang=js"

import "./TermConditionModal.vue?vue&type=style&index=0&id=157f23c7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157f23c7"]])

export default __exports__